//import React from 'react';
//import config from 
//import PropTypes from 'prop-types';
//import classNames from 'classnames';
//import css from './Blog.module.css';

import React from 'react';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '..';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
} from '../../components';
import { SectionHowItWorks } from '../../components';
import css from './PowerOfReviewsPage.module.css';

const PowerOfReviewsPage = () => {
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);

  // prettier-ignore
  return (
    <StaticPage
      title="The Power of Reviews"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'PowerOfReviewsPage',
        description: 'The Power of Reviews: Building Trust and Credibility on Lenddit',
        name: 'The Power of Reviews',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

       <LayoutWrapperMain className={css.staticPageWrapper}>
        <div>
         <h1>The Power of Reviews: Building Trust and Credibility on Lenddit</h1>

         <h2>Introduction</h2>
         <p>In the world of peer-to-peer rentals, trust is the currency that drives transactions. On platforms like Lenddit, where individuals rent tools to and from each other, establishing credibility is crucial. One of the most effective ways to build this trust is through reviews. In this blog post, we'll explore the power of reviews and how they can help you build trust and credibility on Lenddit.</p>
      
         <h2>The Importance of Reviews</h2>
         <p>Reviews serve as social proof, providing potential renters with insights into previous users' experiences. They offer an unbiased perspective on the quality of the tool, the accuracy of the listing, and the lender's reliability. In essence, reviews help potential renters make informed decisions about whether to rent a particular tool or not.</p>
      
         <h2>Building Trust Through Reviews</h2>
         <p>Trust is a vital element in the sharing economy. Renters want to know that the tool they are renting is in good condition and that the lender is reliable. Reviews can help build this trust in several ways:</p>
         
         <p>1. Transparency: Reviews provide transparency, allowing potential renters to see the experiences of previous renters. This transparency can help build trust, as it shows that the lender has nothing to hide.</p>
         <p>2. Reliability: Positive reviews can demonstrate a lender's reliability. If previous renters have had good experiences, it suggests that the lender is dependable and trustworthy.</p>
         <p>3. Quality Assurance: Reviews can also provide assurance about the quality of the tool. If the tool has received positive reviews, it suggests that it is in good condition and performs as expected.</p>
        
         <h2>Encouraging Reviews</h2>
         <p>As a lender on Lenddit, it's important to encourage your renters to leave reviews. Here are a few tips:</p>

         <p>1. Provide Excellent Service: The best way to get positive reviews is to provide excellent service. Ensure your tool is in good condition, be responsive to renters' inquiries, and be punctual for pick-ups and returns.</p>
         <p>2. Ask for Reviews: Don't be shy about asking for reviews. After a successful rental, send a message to the renter thanking them for their business and asking them to leave a review.</p>
         <p>3. Respond to Reviews: Whether positive or negative, always respond to your reviews in a timely manner. Thank the renter for their feedback and address any issues they may have raised. This shows that you value their opinion and are committed to improving your service.</p>
      
         <h2>Conclusion</h2>
         <p>In conclusion, reviews are a powerful tool for building trust and credibility on Lenddit. They provide transparency, demonstrate reliability, and assure quality. As a lender, encouraging and responding to reviews should be a key part of your strategy. Remember, a strong reputation can lead to more rentals and greater success on Lenddit.</p>
         <p>Written by, The Lenddit Team</p>

        </div>
      </LayoutWrapperMain> 

      <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};


export default PowerOfReviewsPage;
